import { Div, RefBool } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";
import { AccordionButton } from "./AccordionButton";
import { AccordionContent } from "./AccordionContent";


export class Accordion extends Div
{
    constructor(title: string, content: appendable[], testId?: string)
    {
        super();
        this.Class("accordion__item product-accordion__item");

        const showContent = new RefBool(false).Storable(`accordion-${title}`);

        const btn = new AccordionButton(title)
            .Attribute("data-testid", testId)
            .OnClick(() => showContent.Toggle());

        const cnt = new AccordionContent(content)
            .Visible(showContent, "flex");

        this.Append(
            btn,
            cnt
        );
    }
}
